import { useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { DepositItemHelper } from '../../../Editable/PaymentDepositItem/helper';

export function usePaymentMethod({ form, transactionType }) {
    const settings = useSelector(state => state.List.settings, shallowEqual);
    const onPaymentMethodCreate = useCallback(paymentMethod => {
        // const hasDefaultFeeText = DepositItemHelper.isFeeNonZero(paymentMethod?.fee_text);
        // const defaultFeeAccount = paymentMethod?.fee_account_id ||
        //                             settings.default_transaction_fee_account_id;

        const {
            showFee,
            defaultFeeAccount,
            feeAmount,
        } = DepositItemHelper.getDefaultFeeInfo(transactionType, paymentMethod, settings);

        form.setFieldsValue({
            payment_method_id: paymentMethod.id,
            account_id: paymentMethod.account_id,
            fee_amount: showFee ? feeAmount : null,
            fee_text: showFee ? paymentMethod.fee_text : null,
            fee_account_id: showFee ? defaultFeeAccount : null,
        });
    }, [form, settings, transactionType]);

    return {
        onPaymentMethodCreate,
    };
}
